// <head> metadata for DbosConductorPage (https://www.dbos.dev/dbos-conductor).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS Conductor - Workflow Ops Control Center',
    },
    {
      name: 'description',
      content: 'Ensure reliability, scalability, and accuracy across all your AI agents and workflows.',
    },
    {
      property: 'og:title',
      content: 'DBOS Conductor - Workflow Ops Control Center',
    },
    {
      property: 'og:description',
      content: 'Ensure reliability, scalability, and accuracy across all your AI agents and workflows.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/69dc74701c1013813b599200_DBOS-Conductor-Workflow-Ops.png',
    },
    {
      name: 'twitter:title',
      content: 'DBOS Conductor - Workflow Ops Control Center',
    },
    {
      name: 'twitter:description',
      content: 'Ensure reliability, scalability, and accuracy across all your AI agents and workflows.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/69dc74701c1013813b599200_DBOS-Conductor-Workflow-Ops.png',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/dbos-conductor',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
